import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import SophisticatedTooltipLink from '@wix/da-ds/pkg/tooltips/SophisticatedTooltipLink';
import TierBadge from '@wix/da-ds/pkg/Badges/TierBadge';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
import { getDeviationType } from '../../../DeviationViews/_helpers';
import { DeviationTypes } from '../../../types/deviation';
import SophisticatedTooltip from '../../../Popover/Preset/SophisticatedTooltip';
import SubscribeToUnlockTooltip from '../SubscribeToUnlockTooltip';
import s from './SubscribersOnly.scss';
var TOOLTIP_WIDTH_PX = 256;
var SubscribersOnly = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, className = _a.className, textClassName = _a.textClassName;
    var t = useTranslation().t;
    var _d = useSubscriptionTier(deviation), tier = _d.tier, isTier = _d.isTier, isUserSubscribed = _d.isUserSubscribed, isOwner = _d.isOwner, subscriptionsTabUrl = _d.subscriptionsTabUrl, needsSubscription = _d.needsSubscription;
    if (!tier || !tier.author) {
        return null;
    }
    var heading;
    var description = tier.title;
    switch (getDeviationType(deviation)) {
        case DeviationTypes.JOURNAL:
            heading = t('deviation.tier.subscribersOnly.tooltip.unlockedJournal');
            break;
        case DeviationTypes.STATUS:
            heading = t('deviation.tier.subscribersOnly.tooltip.unlockedPost');
            break;
        default:
            heading = t('deviation.tier.subscribersOnly.tooltip.unlockedContent');
    }
    if (isOwner) {
        // when the owner is viewing an in-tier, we show a list of the tiers
        // containing this deviation in the description and a count in the header
        var inTiers = ((_c = (_b = deviation.extended) === null || _b === void 0 ? void 0 : _b.relatedStreams) === null || _c === void 0 ? void 0 : _c.inTiers) || [];
        heading = t('deviation.tier.subscribersOnly.tooltip.owner.tierCount', {
            // note: the inTiers list includes the current tier
            count: inTiers.length,
        });
        description = inTiers.map(function (otherTier) { return otherTier.title; }).join('\n');
    }
    var contents = (React.createElement("div", { className: s['contents'] },
        React.createElement(TierBadge, { size: 40 }),
        React.createElement("span", { className: classnames(s['text'], textClassName) }, t('deviation.tier.subscribersOnly'))));
    // no tooltip for tier deviation viewed by owner
    if (isTier && isOwner) {
        return React.createElement("div", { className: classnames(s['root'], className) }, contents);
    }
    var isAnUnsubscribedTier = isTier && !isUserSubscribed && !isOwner;
    var linkText = isOwner
        ? t('deviation.tier.subscribersOnly.tooltip.subscriptionsLinkOwner')
        : t('deviation.tier.subscribersOnly.tooltip.subscriptionsLink');
    return (React.createElement("div", { className: classnames(s['root'], className) }, needsSubscription || isAnUnsubscribedTier ? (React.createElement(SubscribeToUnlockTooltip, { deviation: deviation }, contents)) : (React.createElement(SophisticatedTooltip, { size: "large", placement: "top", width: TOOLTIP_WIDTH_PX, heading: heading, description: description, postfix: React.createElement(SophisticatedTooltipLink, { href: subscriptionsTabUrl, className: s['subs-link'] }, linkText) }, contents))));
};
SubscribersOnly.displayName = 'SubscribersOnly';
export default SubscribersOnly;
//# sourceMappingURL=SubscribersOnly.js.map